import React from 'react';
import Tables from 'components/Table';
import { FundAllocationType } from 'store/modules/ExistingPolicies/types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  cels: {
    paddingLeft: '3.5rem'
  }
});
interface PolicyDetailsProps {
  funds: Array<FundAllocationType>;
}

const PolicyDetails = ({ funds }: PolicyDetailsProps) => {
  const classes = useStyles();

  return (
    <Tables.Table>
      <Tables.TableHead
        cells={[
          'Fund',
          'Sector',
          'OCF',
          'Transaction Cost',
          '1 Year',
          '3 Years',
          '5 Years'
        ]}
        className={classes.cels}
      />
      <Tables.TableBody>
        {funds.map(({ fund }: FundAllocationType) => {
          const ocfPercentage = parseFloat(fund.ocf) * 100;
          const tradingCosts = parseFloat(fund.trading_costs) * 100;

          return (
            <Tables.TableRow key={fund.id}>
              <Tables.TableCell className={classes.cels}>
                {fund.name}
              </Tables.TableCell>
              <Tables.TableCell className={classes.cels}>
                {fund.sector_name || '-'}
              </Tables.TableCell>
              <Tables.TableCell className={classes.cels}>
                {ocfPercentage.toFixed(2)}%
              </Tables.TableCell>
              <Tables.TableCell className={classes.cels}>
                {tradingCosts.toFixed(2)}%
              </Tables.TableCell>
              <Tables.TableCell className={classes.cels}></Tables.TableCell>
              <Tables.TableCell className={classes.cels}></Tables.TableCell>
              <Tables.TableCell className={classes.cels}></Tables.TableCell>
            </Tables.TableRow>
          );
        })}
      </Tables.TableBody>
    </Tables.Table>
  );
};

export default PolicyDetails;
